export enum QueryType {
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
  Voucher = 'voucher',
}
